// Round a rational number to the nearest tenth. Examples:
// 4.7 -> 4.5
// 4.75 -> 5
export const roundToNearestHalf = num => {
  return Math.round(num * 2) / 2;
};
